<template>
<div class="uploadBox">
    <h3>{{headerMessage}}</h3>
    <form role="form" enctype="multipart/form-data" @submit.prevent="onSubmit">
        <v-alert dismissible v-if="successMsg !== ''" type="success" color="green darken-4">
            <h5>OPERACIÓN EXITOSA!!</h5><span v-html="successMsg"></span>
        </v-alert>
        <v-alert dismissible v-if="errorMsg !== ''" type="error" color="red darken-4" >
            <h5>OPERACIÓN NO PERMITIDA!!</h5><span v-html="errorMsg"></span>

        </v-alert>
     
        <div class="uploadBoxMain" v-if="!itemsAdded">
            <div class="form-group">
                <div class="dropArea" @ondragover="onChange" :class="dragging ? 'dropAreaDragging' : ''" @dragenter="dragging=true" @dragend="dragging=false" @dragleave="dragging=false">
                    <h5>{{dropAreaPrimaryMessage}}</h5>
                    <input type="file" id="items" name="items[]" required multiple @change="onChange" accept=".txt">
                    <p class="help-block">{{dropAreaSecondaryMessage}}</p>
                </div>
            </div>
        </div>

     
        <div class="uploadBox2Main" v-else>
            <div class="text-center">
                <v-container class="pa-1">
                    <v-row>
                        <v-col v-for="(name, x) in itemsNames" :key="'f'+x" cols="4" md="4">
                            <v-card  variant="tonal" min-width="300" max-width="300" max-height="350" class="pa-1">
                                <v-card-title class="secondary white--text pa-0 justify-center align-center" >
                                <span style="font-size:12px"><strong>{{name.substring(0, 30)}}</strong></span>
                                   
                                </v-card-title>
                                <v-card-actions class="pa-1" style="position:relative; margin-top:-28px;">

                                <v-btn x-small icon color="white" title="Vista Previa" v-tippy @click.native="vista(name, itemsContenido[x] )">
                                    <v-icon>search</v-icon>
                                </v-btn>

                                <v-spacer></v-spacer>
                                <v-btn x-small icon color="white" @click.native="eliminar(x)" title="Eliminar" v-tippy>
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                </v-card-actions>
                                <v-card-text class="pa-1">
                                    <table v-if="itemsContenido[x] != undefined" class="pa-0" style="font-size:12px; width:100%; border: 1px double #a94442;">
                                    <tr class="pa-0" >
                                    <td class="pa-0 pl-1" style="text-align:left; line-height: 120%; ">
                                    Tipo de Informe:<b style="color:navy;"> {{ nombreTipoDocumento(itemsContenido[x].split(/\r\n|\n/)[0].split('|')[0]) }}</b><br/>
                                    </td>
                                    </tr>
                                    
                                    </table>
                                  
                                    <div class="global">
                                        <div class="contenido">
                                            <span class="text-left">
                                                <p style="word-wrap: break-word;"><small>{{itemsContenido[x]}}</small></p>
                                            </span>
                                        </div>
                                    </div>
                                </v-card-text>
                                
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-dialog v-model="dialog" width="500">

                        <v-card>
                            <v-card-title class="text-h5 grey lighten-2">
                                {{titulo}}
                            </v-card-title>

                            <v-card-text>
                                <div class="vista">
                                    <div class="contenido">
                                        <span class="text-left">
                                            <p v-if="postURL!='guardar_informe_descargo'" style="word-wrap: break-all;"><small>{{contenido}}</small></p>
                                            <p v-if="postURL=='guardar_informe_descargo'">
                                                <pre><small>{{contenido}}</small></pre>
                                            </p>
                                        </span>
                                    </div>
                                </div>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="dialog = false">
                                    CERRAR
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-container>

            </div>

            <div class="loader" v-if="isLoaderVisible">
                <div class="loaderImg"></div>
            </div>
        </div>
        <div>

            <v-card-actions>
                <v-btn @click.native="modal=false; removeItems();successMsg = ''; errorMsg = '';">
                    <v-icon>cancel</v-icon> Limpiar
                </v-btn>
                <v-spacer></v-spacer>

                <v-col v-if="planta_referencia" cols="12" sm="6" md="3">
                  
                </v-col>
                <v-btn color="success" :disabled="itemsAdded < minItems || itemsAdded > maxItems" @click.native="guardar();">
                    <v-icon>done</v-icon> Cargar
                </v-btn>
            </v-card-actions>

        </div>

    </form>

</div>
</template>

<script>
require('es6-promise').polyfill();
import axios from 'axios';

component: {
    axios
}
export default {
    props: {
        postURL: {
            type: String,
            required: true
        },
        minItems: {
            type: Number,
            default: 1
        },
        maxItems: {
            type: Number,
            default: 30
        },
        method: {
            type: String,
            default: 'post'
        },
        postMeta: {
            type: [String, Array, Object],
            default: ''
        },
        postData: {
            type: [Object],
            default: () => {}
        },
        postHeader: {
            type: [Object],
            default: () => {}
        },
        successMessagePath: {
            type: String,
            required: true
        },
        errorMessagePath: {
            type: String,
            required: true
        },
        headerMessage: {
            type: String,
            default: 'Agregar Archivos'
        },
        dropAreaPrimaryMessage: {
            type: String,
            default: 'Arrastre Archivos Aqui..'
        },
        dropAreaSecondaryMessage: {
            type: String,
            default: 'o de click para selecionar..'
        },
        fileNameMessage: {
            type: String,
            default: 'Nombre'
        },
        fileSizeMessage: {
            type: String,
            default: 'Tamaños'
        },
        totalFileMessage: {
            type: String,
            default: 'Total Archivos:'
        },
        totalUploadSizeMessage: {
            type: String,
            default: 'Total tamaño:'
        },
        removeFileMessage: {
            type: String,
            default: 'Limpiar'
        },
        uploadButtonMessage: {
            type: String,
            default: 'Guardar'
        },
        cancelButtonMessage: {
            type: String,
            default: 'Cancelar'
        },
        fileUploadErrorMessage: {
            type: String,
            default: 'Ocurrio un error'
        },
        minFilesErrorMessage: {
            type: String,
            default: 'Minimum files that need to be added to uploader'
        },
        maxFilesErrorMessage: {
            type: String,
            default: 'Maximo número de archivos'
        },
        retryErrorMessage: {
            type: String,
            default: 'Favor de intentar nuevamente'
        },
        httpMethodErrorMessage: {
            type: String,
            default: "No fue posible enviar los archivos verifique su conexión"
        },
        showHttpMessages: {
            type: Boolean,
            default: true
        }
    },

    /*
     * The component's data.
     */
    data() {
        return {
            dragging: false,
            tipos_documento:[],
            plantas: [],
            planta: "",
            items: [],
            itemsAdded: '',
            itemsNames: [],
            itemsSizes: [],
            itemsContenido: [],
            itemsTotalSize: '',
            formData: '',
            successMsg: '',
            errorMsg: '',
            isLoaderVisible: false,
            dialog: false,
            titulo: '',
            contenido: '',
        }
    },
    created: function () {
       // this.cargarPlantas();
        this.getTiposDocumento();
    },
    computed: {
        
        planta_referencia() {
            return  this.$local_storage.get("Modulo16") == 100 ;
        },
        
      
    },
    methods: {
        nombreTipoDocumento(tipo){
            let p = this.tipos_documento.filter(item => {
                            return item.clave == tipo
                        });
            if (p.length > 0) {
                return  p[0].nombre;
            }else{
                return "Desconocido";
            }
        },
        getTiposDocumento: function () {

            axios.post(this.$hostname + "apendices/lista/", {
                    'tabla': 31
                })
                .then(response => {
                    this.tipos_documento = response.data;
                })
                .catch(error => {

                });
            },
        // http://scratch99.com/web-development/javascript/convert-bytes-to-mb-kb/
        bytesToSize(bytes) {
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes === 0) return 'n/a';
            let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            if (i === 0) return bytes + ' ' + sizes[i];
            return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
        },
        vista(t, c) {
            this.titulo = t;
            this.contenido = c;
            this.dialog = true;

        },
        onChange(e) {
            this.removeItems();
            this.successMsg = '';
            this.errorMsg = '';
            this.formData = new FormData();
            let files = e.target.files || e.dataTransfer.files;
            this.itemsAdded = files.length;
            let fileSizes = 0;
            let self = this;
            let msg = "";
            let j = 0;
            for (let x in files) {

                if (!isNaN(x) && files[x].type == "text/plain") {
                    console.log(e.target.files[x] || e.dataTransfer.files[x]);

                    this.items = e.target.files[x] || e.dataTransfer.files[x];

                    this.itemsNames.push(files[x].name);
                    this.itemsSizes.push(this.bytesToSize(files[x].size));
                    fileSizes += files[x].size;
                    this.formData.append('items[]', this.items);

                    let reader = new FileReader()
                    reader.onload = (e) => {
                        self.itemsContenido.push(e.target.result)
                    }
                    reader.readAsText(files[x]);

                } else {
                    if (!isNaN(x))
                        msg += " * Archivo no valido " + files[x].name + "<br/>";
                }
            }
            this.itemsTotalSize = this.bytesToSize(fileSizes);
            this.itemsAdded = this.itemsNames.length;
            this.errorMsg = msg;
        },

        removeItems() {
            this.items = '';
            this.itemsAdded = '';
            this.itemsNames = [];
            this.itemsSizes = [];
            this.itemsContenido = [];
            this.itemsTotalSize = '';
            this.dragging = false;
        },
        eliminar(index) {

            this.itemsNames.splice(index, 1);
            this.itemsSizes.splice(index, 1);
            this.itemsContenido.splice(index, 1);
            delete this.items[index]
            this.itemsAdded = this.itemsAdded - 1;
            this.formData.append('items[]', this.items);
            this.successMsg = "";
            this.errorMsg = "";

        },

     /*    onSubmit() {
            this.isLoaderVisible = true;

            if ((typeof this.postMeta === 'string' && this.postMeta !== '') ||
                (typeof this.postMeta === 'object' && Object.keys(this.postMeta).length > 0)) {
                this.formData.append('postMeta', this.postMeta);
            }

            if (typeof this.postData === 'object' && this.postData !== null && Object.keys(this.postData).length > 0) {
                for (var key in this.postData) {
                    this.formData.append(key, this.postData[key]);
                }
            }

            if (this.method === 'put' || this.method === 'post') {
                axios({
                        method: this.method,
                        url: this.postURL,
                        data: this.formData,
                        headers: this.postHeader
                    })
                    .then((response) => {
                        this.isLoaderVisible = false;
                        // Show success message
                        if (this.showHttpMessages)
                            this.successMsg = response + "." + this.successMessagePath;
                        this.removeItems();
                    })
                    .catch((error) => {
                        this.isLoaderVisible = false;
                        if (this.showHttpMessages)
                            this.errorMsg = error + "." + this.errorMessagePath;
                        this.removeItems();
                    });
            } else {
                if (this.showHttpMessages)
                    this.errorMsg = this.httpMethodErrorMessage;
                this.removeItems();
            }
        },
 */
        guardar: async function () {
            var self = this;
            self.errorMsg = "";
            self.successMsg = "";
            var rfcActual = this.$local_storage.get("rfc").toString().trim().toUpperCase();
            self.$root.$dialogLoader.show("Espere un momento por favor...");
            const filesArray = Array.from(this.formData);
            await Promise.all(filesArray.map(async (x) => {
          //  this.formData.forEach(async function (x) {
                var keyBucket = rfcActual + "/soluciona31/cargados/" + x[1].name;
                var datos = {
                    key: keyBucket,
                    bucket: "production.econnect.ds",
                    type: x[1].type
                }

              await  axios.post(self.$hostname + 's3/upload_url/', datos)
                    .then(async (res) => {
                        if (typeof res.data !== 'undefined') {
                            var urlput = res.data.mensaje;

                           await axios.put(urlput, x[1], {
                                    headers: {
                                        'Content-Type': x[1].type
                                    }
                                })
                                .then(async (res) => {
                                    let formData = {};
                                   
                                    if (self.planta != "") {
                                         formData = {
                                            key: keyBucket,
                                            rfc: rfcActual,
                                            usuario: self.$local_storage.get("email"),
                                            planta: self.planta
                                        };
                                       
                                    }else{
                                        formData = {
                                            key: keyBucket,
                                            rfc: rfcActual,
                                            usuario: self.$local_storage.get("email"),
                                        };
                                    }

                                  await  axios.post(self.$apiSA31 + 'soluciona31/' + self.postURL + '/', formData)
                                        .then(async (res) => {

                                            if (res.data.length > 0 ) {
                                                if(res.data[0].mensaje != undefined)
                                                    self.errorMsg += '<li>' + x[1].name + " " + res.data[0].mensaje + '.</li>';
                                            } else {
                                                
                                                    self.successMsg += '<li>' + x[1].name + ' Se cargo correctamente.</li>';
                                            }

                                        }).catch((error) => { //ya que si el archivo es muy grande recibirá un timeOut, igualmente recibirá notificación al terminar de cargarse
                                            console.log(error);
                                            var mensaje =  " no pudo ser guardado favor de verificarlo.";

                                            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                                                mensaje = error.response.data.mensaje;

                                            self.errorMsg += "<li> " + x[1].name + " " + mensaje + '.</li>';
                                            
                                        });
                                }).catch((error) => {
                                    console.log(error);
                                    self.$root.$dialogLoader.hide();
                                    var mensaje = " no pudo ser guardado favor de verificarlo.";

                                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                                        mensaje = error.response.data.mensaje;

                                    self.errorMsg += "<li> " + x[1].name + " " + mensaje + '.</li>';
                                    
                                });
                           
                        } else {

                           
                            self.errorMsg += " No pudo ser guardado favor de verificarlo.";

                        }
                    }).catch((error) => {
                        console.log(error);
                        var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                            mensaje = error.response.data.mensaje;

                        self.errorMsg += "<li> " + x[1].name + " " + mensaje + '.</li>';
                       
                        //SI NO SE PUDO CARGAR A S3, SE ELIMINA EL REGISTRO DE LA GLOSA                    

                        

                    });
            }));
            self.$root.$dialogLoader.hide();
            self.removeItems();

            //console.log("Intento:",intento);

        },
        cargarPlantas: function () {

            let data = {
                cliente: this.$local_storage.get("id_cliente"),
            };
            axios.post(this.$hostname + "catalogos/referencias/get_referencias/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.plantas = res.data;
                      
                    }
                })
                .catch(err => {
                    console.log();
                });
        },
    }
}
</script>

<style>
.uploadBox {
    position: relative;
    background: #eee;
    padding: 0 1em 1em 1em;
    margin: 1em;
}

.uploadBox h3 {
    padding-top: 1em;
}

.uploadBox .uploadBoxMain {
    position: relative;
    margin-bottom: 1em;
    margin-right: 1em;
}

/* Drag and drop */
.uploadBox .dropArea {
    position: relative;
    width: 100%;
    height: 300px;
    border: 5px dashed #DF7205;
    text-align: center;
    font-size: 2em;
    padding-top: 80px;
}

.uploadBox .dropArea input {
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

/* End drag and drop */

/* Loader */
.uploadBox .loader {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    opacity: 0.9;
}

.uploadBox .loaderImg {
    border: 9px solid #eee;
    border-top: 9px solid #00ADCE;
    border-radius: 50%;
    width: 70px;
    height: 70px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* End Loader */

.uploadBox .errorMsg {
    font-size: 2em;
    color: #a94442;
}

.uploadBox .successMsg {
    font-size: 2em;
    color: #3c763d;
}
</style>
<style scoped>
.global {
    margin-left: 0px;
    margin-top: 3px;
    height: 152px;
    width: auto;
    border: 1px solid #a94442;
    background: #f1f1f1;
    overflow-y: scroll;
    color: blue;

}

.vista {
    margin-left: 0px;
    margin-top: 3px;
    height: 400px;
    width: auto;
    border: 1px solid #ddd;
    background: #FFF;
    overflow-y: scroll;
    color: blue;
}

.contenido {
    padding: 5px;
    height: auto;

}
</style>
